import React from "react";
import { Modal } from "react-bootstrap";
import "./Policy_Modal.css";

/**
 * Small popup window for legal / consent content.
 * Usage:
 *   <Policy_Modal show={show} onHide={close} title="Terms & Conditions">
 *     <SomeContent />
 *   </Policy_Modal>
 */
function Policy_Modal({ show, onHide, title, children }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      scrollable
      className="Policy_Modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
}

export default Policy_Modal;